import { render } from "./FooterComp.vue?vue&type=template&id=9ab41388&ts=true"
import script from "./FooterComp.vue?vue&type=script&lang=ts"
export * from "./FooterComp.vue?vue&type=script&lang=ts"

import "./FooterComp.vue?vue&type=style&index=0&id=9ab41388&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__